import { Controller } from '@hotwired/stimulus';

/** Append or remove nested attribute field groups on admin forms. */
export default class extends Controller {
  static targets = ['container', 'template'];

  add(event) {
    event.preventDefault();
    if (!this.hasTemplateTarget) return;

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, String(Date.now()));
    this.containerTarget.insertAdjacentHTML('beforeend', content);
  }

  remove(event) {
    event.preventDefault();
    const item = event.target.closest('[data-nested-form-target="item"]');
    if (!item) return;

    const destroyField = item.querySelector('input[name*="[_destroy]"]');
    const idField = item.querySelector('input[name*="[id]"]');

    if (destroyField && idField?.value) {
      destroyField.value = '1';
      item.hidden = true;
    } else {
      item.remove();
    }
  }
}
